import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createI18n } from "vue-i18n";
import VueScrollTo from "vue-scrollto";
import { createGtm } from "vue-gtm";
import VueCookies from "vue-cookies";

const i18nData = require("./locales/view/ja.json");
const i18n = createI18n({
  locale: "ja",
  messages: i18nData,
});

const app = createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(VueScrollTo)
  .use(
    createGtm({
      id: "GTM-5MRJPKX",
      enabled: false,
      debug: false,
      ignoredViews: [],
    })
  )
  .use(VueCookies);

app.config.productionTip = false;

app.mount("#app");
